import { styled, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import QRTlogo from "../images/favicon_QRT.png"
import TVLogo from "../images/TV_logo3.png"
import { Link } from "react-router-dom";

const Footer = () => {
  const CustomContainer = styled(Container)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-around",
    gap: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  }));

  const FooterLink = styled("span")(() => ({
    fontSize: "16px",
    color: "secondary",
    fontWeight: "300",
    cursor: "pointer",
    "&:hover": {
      color: "#000",
    },
  }));
  const hideFooter = true;

  return (
    <Box>
      {hideFooter ? null : 
      <div className="bg-inherit w-screen flex justify-center py-1">
        <a 
          href="https://www.qrtsolutions.com" target="_blank" rel="noreferrer"
          className="flex flex-col bg-gray-700 rounded-full w-auto justify-center py-2 px-4"
        >
          <div className=" flex flex-row justify-center px-2">
            <img src={QRTlogo} className="h-12 pl-4"></img>
            <h1 className="text-xl">
              Desarrollado por QRT Solutions
            </h1>
          </div>
          <h1>
            Conoce nuestro sitio web!
          </h1>
        </a>
      </div>}
      <br></br>
      <br></br>
      <CustomContainer>
        <center>
          <Link  href="/" variant="body2" id= "signup-link">
            <img onClick={()=>{window.open("https://www.tradingview.com",)}} src={TVLogo}
                width="250"
                height="70"

            ></img>
          </Link>
        </center>
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              color: "secondary",
              fontWeight: "700",
              mb: 2,
              textAlign: "justify"
            }}>
            TradingView, una plataforma para inversores, proporciona tecnología a QRT Solutions. Con sus herramientas analíticas avanzadas, como el  <FooterLink onClick={()=>{window.open("https://www.tradingview.com/economic-calendar/",)}}> calendario económico </FooterLink>
            o el 
            <FooterLink onClick={()=>{window.open("https://www.tradingview.com/screener/",)}}> stock screener </FooterLink>
            , puede realizar un seguimiento de gráficos de símbolos detallados como el 
            <FooterLink onClick={()=>{window.open("https://www.tradingview.com/symbols/XAUUSD/",)}}> XAUUSD </FooterLink>
            , para mantenerse siempre informado sobre los movimientos del mercado. 
          </Typography>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default Footer;